<template>
<!-- eslint-disable max-len -->
<div
  class="prompt animated fadeIn"
>
  <h3>
    Please change your password.
    <a href="" @click.prevent="close" class="btn btn-sm float-right mb-3" style="font-size: 1.5rem;">
      &times;
    </a>
  </h3>

  <div class="prompt-text">
  </div>

  <button
    class="btn modal-bottom and-left"
    @click.prevent.once="close">
    Close
  </button>
  <button
    class="btn modal-bottom and-right"
    @click.prevent.once="accept">
    Change Password
  </button>
</div>
</template>

<script>
export default {
  methods: {
    accept() {
      this.$router.push('/user/password');
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.prompt {
  background-color: rgba(0, 0, 7, 0.76);
  color: white;
  padding: 15px;
  transition: all .15s linear;
  position: absolute;
  width: 44vw;
  height: 20vh;
  bottom: 0;
  left: calc(28vw);
  z-index: 1000;
}
.modal-bottom {
  position: absolute;
  bottom: 15px;
  font-size: 110%;
  padding: 5px;
}
.and-left {
  left: 15px;
}
.and-right {
  right: 15px;
}
.prompt-text {
  overflow: auto;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/modals/ChangePasswordPrompt.vue